import * as React from 'react';
import { clsx } from 'clsx';
import { AnimatedContent } from '../AnimatedContent';
import { Close } from './components/Close';
import * as styles from './styles.css';
import { jsx as _jsx } from "react/jsx-runtime";
export function MainButton(_ref) {
  var closedState = _ref.closedState,
    onClick = _ref.onClick;
  return /*#__PURE__*/_jsx("a", {
    className: clsx(styles['chat-btn'], !closedState && styles['closed-state']),
    onClick: onClick,
    "data-testid": "ConsultantWidgetMainButton",
    children: closedState ? /*#__PURE__*/_jsx(Close, {}) : /*#__PURE__*/_jsx(AnimatedContent, {})
  });
}